/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MelcoFusionModelsCustomProduct,
    MelcoFusionModelsCustomProductFromJSON,
    MelcoFusionModelsCustomProductFromJSONTyped,
    MelcoFusionModelsCustomProductToJSON,
    MelcoFusionModelsFusionConfiguratorSetting,
    MelcoFusionModelsFusionConfiguratorSettingFromJSON,
    MelcoFusionModelsFusionConfiguratorSettingFromJSONTyped,
    MelcoFusionModelsFusionConfiguratorSettingToJSON,
    MelcoFusionModelsProductionStatusHistory,
    MelcoFusionModelsProductionStatusHistoryFromJSON,
    MelcoFusionModelsProductionStatusHistoryFromJSONTyped,
    MelcoFusionModelsProductionStatusHistoryToJSON,
    MelcoFusionModelsSessionPreview,
    MelcoFusionModelsSessionPreviewFromJSON,
    MelcoFusionModelsSessionPreviewFromJSONTyped,
    MelcoFusionModelsSessionPreviewToJSON,
} from './';

/**
 * 
 * @export
 * @interface MelcoFusionModelsSession
 */
export interface MelcoFusionModelsSession {
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsSession
     */
    session_id?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsSession
     */
    session_status?: number;
    /**
     * 
     * @type {number}
     * @memberof MelcoFusionModelsSession
     */
    production_status?: number;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsSession
     */
    start_timestamp?: Date;
    /**
     * 
     * @type {Date}
     * @memberof MelcoFusionModelsSession
     */
    end_timestamp?: Date | null;
    /**
     * 
     * @type {MelcoFusionModelsCustomProduct}
     * @memberof MelcoFusionModelsSession
     */
    product?: MelcoFusionModelsCustomProduct;
    /**
     * 
     * @type {Array<MelcoFusionModelsSessionPreview>}
     * @memberof MelcoFusionModelsSession
     */
    previews?: Array<MelcoFusionModelsSessionPreview> | null;
    /**
     * 
     * @type {string}
     * @memberof MelcoFusionModelsSession
     */
    selected_color_image_id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof MelcoFusionModelsSession
     */
    is_edits_applied?: boolean;
    /**
     * 
     * @type {MelcoFusionModelsFusionConfiguratorSetting}
     * @memberof MelcoFusionModelsSession
     */
    configurator_setting?: MelcoFusionModelsFusionConfiguratorSetting;
    /**
     * 
     * @type {Array<MelcoFusionModelsProductionStatusHistory>}
     * @memberof MelcoFusionModelsSession
     */
    production_status_history?: Array<MelcoFusionModelsProductionStatusHistory> | null;
}

export function MelcoFusionModelsSessionFromJSON(json: any): MelcoFusionModelsSession {
    return MelcoFusionModelsSessionFromJSONTyped(json, false);
}

export function MelcoFusionModelsSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoFusionModelsSession {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'session_id': !exists(json, 'session_id') ? undefined : json['session_id'],
        'session_status': !exists(json, 'session_status') ? undefined : json['session_status'],
        'production_status': !exists(json, 'production_status') ? undefined : json['production_status'],
        'start_timestamp': !exists(json, 'start_timestamp') ? undefined : (new Date(json['start_timestamp'])),
        'end_timestamp': !exists(json, 'end_timestamp') ? undefined : (json['end_timestamp'] === null ? null : new Date(json['end_timestamp'])),
        'product': !exists(json, 'product') ? undefined : MelcoFusionModelsCustomProductFromJSON(json['product']),
        'previews': !exists(json, 'previews') ? undefined : (json['previews'] === null ? null : (json['previews'] as Array<any>).map(MelcoFusionModelsSessionPreviewFromJSON)),
        'selected_color_image_id': !exists(json, 'selected_color_image_id') ? undefined : json['selected_color_image_id'],
        'is_edits_applied': !exists(json, 'is_edits_applied') ? undefined : json['is_edits_applied'],
        'configurator_setting': !exists(json, 'configurator_setting') ? undefined : MelcoFusionModelsFusionConfiguratorSettingFromJSON(json['configurator_setting']),
        'production_status_history': !exists(json, 'production_status_history') ? undefined : (json['production_status_history'] === null ? null : (json['production_status_history'] as Array<any>).map(MelcoFusionModelsProductionStatusHistoryFromJSON)),
    };
}

export function MelcoFusionModelsSessionToJSON(value?: MelcoFusionModelsSession | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'session_id': value.session_id,
        'session_status': value.session_status,
        'production_status': value.production_status,
        'start_timestamp': value.start_timestamp === undefined ? undefined : (value.start_timestamp.toISOString()),
        'end_timestamp': value.end_timestamp === undefined ? undefined : (value.end_timestamp === null ? null : value.end_timestamp.toISOString()),
        'product': MelcoFusionModelsCustomProductToJSON(value.product),
        'previews': value.previews === undefined ? undefined : (value.previews === null ? null : (value.previews as Array<any>).map(MelcoFusionModelsSessionPreviewToJSON)),
        'selected_color_image_id': value.selected_color_image_id,
        'is_edits_applied': value.is_edits_applied,
        'configurator_setting': MelcoFusionModelsFusionConfiguratorSettingToJSON(value.configurator_setting),
        'production_status_history': value.production_status_history === undefined ? undefined : (value.production_status_history === null ? null : (value.production_status_history as Array<any>).map(MelcoFusionModelsProductionStatusHistoryToJSON)),
    };
}


